<template>
  <div class="content-warp">
    <a-row :gutter="24">
      <a-col :span="6">
        <div class="content-panle bg-white" style="height: 670px">
          <SingleTreeWithSearch
            ref="treeArea"
            :mixNodeName="false"
            @update:selectedOrg="handleSelectedOrg"
          ></SingleTreeWithSearch>
        </div>
      </a-col>
      <a-col :span="18">
        <div class="content-panle bg-white">
          <div class="table-operation-area">
            <div class="search-form" style="text-align: left">
              <TableTips
                :total="pagination.total"
                :selected="selectedRowKeys.length"
                @clearAllSelected="
                  () => {
                    selectedRowKeys = []
                    selectedRowItems = []
                  }
                "
              />
            </div>
            <div class="btn-area-inline" style="text-align: right">
              <a-button
                type="primary"
                :disabled="!targetOrg"
                @click="
                  () => {
                    editModalVisible = true
                    modalTitle = $t('orgMana.newOrg')
                  }
                "
                >{{ $t('orgMana.newOrg') }}</a-button
              >
              <a-button
                type="danger"
                :disabled="!selectedRowKeys.length"
                @click="handleDeleteOrgs"
                >{{ $t('orgMana.deleteOrgBtn') }}</a-button
              >
            </div>
          </div>

          <a-table
            class="table-area"
            style="min-height: 584px"
            :rowSelection="{
              selectedRowKeys: selectedRowKeys,
              onChange: handleTableItemSelected
            }"
            :columns="tableColumns"
            :dataSource="tableData"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
          >
            <template slot="operation" slot-scope="text, record">
              <div v-if="record.operation">
                <a
                  class="operation-botton"
                  v-for="item in record.operation"
                  :key="item.type"
                  :disabled="item.disabled"
                  :style="{ color: item.color }"
                  @click="item.callback(record)"
                >
                  {{ $t(item.type) }}
                </a>
              </div>
            </template>
          </a-table>
        </div>
      </a-col>
    </a-row>

    <!-- 编辑组织信息 -->
    <a-modal
      :title="modalTitle"
      :visible="editModalVisible"
      :okText="$t('orgMana.submitBtn')"
      :cancelText="$t('orgMana.cancelBtn')"
      @ok="handleSubmitOrgInfo"
      :confirmLoading="confirmLoading"
      @cancel="
        () => {
          editModalVisible = false
        }
      "
      :afterClose="handleEditModalHide"
    >
      <a-form-model
        ref="editForm"
        :model="editform"
        :rules="editformRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item :label="$t('orgMana.orgName')" prop="name">
          <a-input v-model="editform.name" />
        </a-form-model-item>

        <a-form-model-item :label="$t('orgMana.remark')">
          <a-input
            v-model="editform.remark"
            type="textarea"
            :autoSize="{ minRows: 2, maxRows: 2 }"
            @change="
              () => {
                editform.remark = editform.remark.substr(0, 20)
              }
            "
          />
          <p class="textarea-words-limit">{{ editform.remark.length }}/20</p>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 设置二维码有效期 -->
    <a-modal
      :title="$t('orgMana.orgQRCode')"
      :visible="setQRCodeValidTimeModalVisible"
      :okText="$t('orgMana.submitBtn')"
      :cancelText="$t('orgMana.cancelBtn')"
      @ok="handleConfirmQRCodeValidTime"
      :confirmLoading="QRCodeValidTimeModalLoading"
      @cancel="
        () => {
          setQRCodeValidTimeModalVisible = false
        }
      "
      :afterClose="handleSetQRCodeValidTimeModalHide"
    >
      <a-form-model
        ref="QRCodevalidTimeForm"
        :model="QRCodevalidTimeForm"
        :rules="QRCodevalidTimeFormRules"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-form-model-item
          required
          :label="$t('orgMana.QRCodeValidity')"
          prop="validTimeType"
        >
          <a-radio-group v-model="QRCodevalidTimeForm.validTimeType">
            <a-radio :value="Number(1)">
              {{ $t('orgMana.QRCodeLongTerm') }}
            </a-radio>
            <a-radio :value="Number(2)">
              {{ $t('orgMana.QRCodeUserDefined') }}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          v-if="QRCodevalidTimeForm.validTimeType === 2"
          required
          :label="$t('orgMana.QRCodeExpiryTime')"
          prop="expiredTime"
        >
          <a-date-picker
            show-time
            :locale="datePickerLang"
            format="YYYY-MM-DD HH:mm:ss"
            :disabledDate="
              current =>
                current &&
                (current < moment().endOf('day') ||
                  current > moment().add(1, 'months'))
            "
            :placeholder="$t('orgMana.QRCodeExpiryTimeTxt')"
            v-model="QRCodevalidTimeForm.expiredTime"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 显示二维码 -->
    <a-modal
      :title="$t('orgMana.orgQRCode')"
      :visible="QRCodeModalVisible"
      :footer="null"
      @cancel="
        () => {
          QRCodeModalVisible = false
        }
      "
      :afterClose="
        () => {
          codeString = ''
          expiredTimeString = ''
          setQRCodeTargetFullName = ''
          setQRCodeTargetId = ''
        }
      "
    >
      <QRCode
        v-if="codeString"
        :codeString="codeString"
        :codeName="setQRCodeTargetFullName"
      >
        <template v-slot:describe>
          <p style="text-align: center; color: #fa8c16">
            {{ $t('orgMana.QRCodeUseDesc') }}
          </p>
          <p
            style="text-align: center; color: #1890ff"
            v-if="moment(expiredTimeString).diff(moment(), 'years') >= 99"
          >
            {{ $t('orgMana.QRCodeValidityDesc') }}
          </p>
          <p style="text-align: center; color: #1890ff" v-else>
            {{ $t('orgMana.QRCodeExpiryTimeDesc') }} {{ expiredTimeString }} ！
          </p>
        </template>
      </QRCode>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import SingleTreeWithSearch from '@/components/SingleTreeWithSearch'
import QRCode from '@/components/QRCode'
import TableTips from '@/components/TableTips'
import { mapState } from 'vuex'
import { parsePromiseAllRes, deleteSelectedRow } from '../../utils/utils'
import { getSubOrgs, createOrg, modifyOrg, deleteOrg } from '@/api/orgMana'
import { createQRCode } from '@/api/personalMana'

export default {
  name: 'orgManaIndex',
  components: {
    SingleTreeWithSearch,
    QRCode,
    TableTips
  },
  inject: ['datePickerLang'],
  data() {
    return {
      targetOrg: null, // 组织树中选中的对象

      loading: false, // 列表内容是否在加载中
      tableData: [], // 列表数据源
      // 列表表头项
      tableColumns: this.getTableColumns(),
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      selectedRowKeys: [],
      selectedRowItems: [],

      // 编辑组织新增模态框属性
      editTargetOrg: null,
      editModalVisible: false,
      modalTitle: '',
      confirmLoading: false,
      editform: { name: '', remark: '' },
      editformRules: {
        name: [
          {
            required: true,
            message: this.$t('orgMana.orgNameBlank'),
            trigger: ['blur', 'change']
          },
          {
            max: 20,
            message: this.$t('orgMana.orgNameWarning'),
            trigger: 'change'
          }
        ]
      },

      // 组织二维码
      setQRCodeTargetId: '',
      setQRCodeTargetFullName: '',

      setQRCodeValidTimeModalVisible: false,
      QRCodeValidTimeModalLoading: false,

      QRCodevalidTimeForm: {
        validTimeType: 1,
        expiredTime: undefined
      },
      QRCodevalidTimeFormRules: {
        expiredTime: [
          {
            required: true,
            message: this.$t('orgMana.QRCodeExpiryTimeBlank'),
            trigger: ['blur', 'change']
          }
        ]
      },

      expiredTimeString: '',
      QRCodeModalVisible: false,
      codeString: ''
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang: function(lang) {
      this.editformRules.name = [
        {
          required: true,
          message: this.$t('orgMana.orgNameBlank'),
          trigger: ['blur', 'change']
        },
        {
          max: 20,
          message: this.$t('orgMana.orgNameWarning'),
          trigger: 'change'
        }
      ]

      this.QRCodevalidTimeFormRules.expiredTime = [
        {
          required: true,
          message: this.$t('orgMana.QRCodeExpiryTimeBlank'),
          trigger: ['blur', 'change']
        }
      ]

      this.tableColumns = this.getTableColumns()
    }
  },
  created() {
    // console.log('--datePickerLang--', this.datePickerLang)
  },
  mounted() {},
  methods: {
    moment,

    // 获取表头项目名
    getTableColumns() {
      return [
        {
          title: this.$t('orgMana.listUpOrg'),
          dataIndex: 'upOrg',
          width: '15%'
        },
        {
          title: this.$t('orgMana.listOrgName'),
          dataIndex: 'orgName',
          width: '30%'
        },
        {
          title: this.$t('orgMana.listRemark'),
          dataIndex: 'remark',
          width: '25%'
        },
        {
          title: this.$t('orgMana.listOperation'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },

    // 选定一个组织
    handleSelectedOrg(data) {
      // console.log('-------handleSelectedOrg--------', data);
      this.targetOrg = data
      this.pagination.current = 1
      deleteSelectedRow(undefined, this.selectedRowKeys, this.selectedRowItems)
      this.getOrgData()
    },

    // 获取组织列表数据
    async getOrgData(page) {
      try {
        this.loading = true
        const res = await getSubOrgs({
          parentDeptId: this.targetOrg.id,
          page: page || this.pagination.current,
          perPage: this.pagination.pageSize,
          containAllChildren: false // 不查询子组织
        })
        this.loading = false

        this.tableData = this.createOrgTableData(res.data.collection)
        this.pagination.total = res.data.size
      } catch (error) {
        this.loading = false
      }
    },
    // 构建组织列表数据
    createOrgTableData(data) {
      return data.map(item => {
        return {
          key: item.id,
          id: item.id,
          upOrg: item.parentDeptName,
          orgName: item.name,
          remark: item.remark,
          fullName: item.fullName,
          operation: [
            {
              type: 'orgMana.listBtnEdit',
              disabled: !item.parentDeptName,
              callback: this.handleEditOrg
            }
            // ,
            // {
            //   type: 'orgMana.listBtnQRCode',
            //   disabled: false,
            //   color: '#fa8c16',
            //   callback: this.handleSetQRCodeValidTime
            // }
          ]
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      // console.log('-------handleTableChange------', pagination);
      this.pagination.current = pagination.current
      this.getOrgData()
    },

    handleTableItemSelected(rowKeys, rowItems) {
      this.selectedRowKeys = rowKeys
      this.selectedRowItems = rowItems
    },

    // 修改编辑单个组织内容
    handleEditOrg(data) {
      // console.log('-------handleEditOrg-------', data)
      this.editTargetOrg = data
      this.editform = {
        name: this.editTargetOrg.orgName,
        remark: this.editTargetOrg.remark
      }
      this.editModalVisible = true
      this.modalTitle = this.$t('orgMana.editOrg')
    },
    // 新增\编辑组织模态框
    handleSubmitOrgInfo() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          try {
            this.confirmLoading = true
            const isModify = this.editTargetOrg && this.editTargetOrg.id
            const request = isModify ? modifyOrg : createOrg
            await request({
              parentId: this.targetOrg.id,
              id: isModify ? this.editTargetOrg.id : null,
              name: this.editform.name,
              remark: this.editform.remark
            })

            this.editModalVisible = false
            this.$notification.success({
              message: this.$t('orgMana.submitRequestSuccess')
            })

            this.getOrgData(isModify ? null : 1)
            this.$refs.treeArea.refreshTree(this.targetOrg)
          } catch (error) {
            this.confirmLoading = false
          }
        } else {
          return false
        }
      })
    },
    handleEditModalHide(e) {
      this.confirmLoading = false
      this.editform = { name: '', remark: '' }
      this.editTargetOrg = null
      this.$refs.editForm.resetFields()
    },

    // 触发删除组织
    handleDeleteOrgs() {
      this.$confirm({
        title: this.$t('orgMana.deleteWarning'),
        content: new Function('count', this.$t('orgMana.deleteWarningDesc'))(
          this.selectedRowKeys.length
        ),
        okText: this.$t('orgMana.confirmBtn'),
        cancelText: this.$t('orgMana.cancelBtn'),
        onOk: this.deleteOrgs,
        onCancel() {}
      })
    },
    // 删除组织
    deleteOrgs() {
      const deletePromises = this.selectedRowKeys.map(item =>
        this.getDeleteOrgsAxios(item)
      )
      Promise.all(deletePromises)
        .then(resArr => {
          // 处理 Promise.all 返回结果
          const { successRes } = parsePromiseAllRes(this, resArr, {
            successMsg: new Function(
              'count',
              this.$t('orgMana.batchDeleteSuccess')
            ),
            failMsg: new Function('count', this.$t('orgMana.batchDeleteFail')),
            targets: this.selectedRowItems.map(item => {
              return { id: item.id, name: item.orgName }
            })
          })

          // 有删除成功的结果，则刷新列表
          if (successRes.length) {
            this.refreshOrgTable(successRes.length)
          }
        })
        .catch(error => {
          // console.log(error)
        })
    },
    // 删除后刷新列表
    refreshOrgTable(successCount) {
      // 刷新列表
      // 若当前页未全部删除，则查询但前页；
      // 若当前页全部删除，则查询上一页；
      // 若当前为第一页，则查询第一页；
      if (this.tableData.length === successCount) {
        --this.pagination.current
      }
      this.getOrgData(this.pagination.current || 1)
      // 刷新机构树
      this.$refs.treeArea.refreshTree(this.targetOrg)
    },
    // 删除组织的请求
    async getDeleteOrgsAxios(id) {
      try {
        const res = await deleteOrg({ id })
        deleteSelectedRow(id, this.selectedRowKeys, this.selectedRowItems)
        return Promise.resolve({ res: res, targetId: id })
      } catch (error) {
        return Promise.resolve({ res: error, targetId: id })
      }
    },

    // 打开设置二维码有效期模态框
    handleSetQRCodeValidTime(data) {
      // console.log('----handleSetQRCodeValidTime---', data)
      this.setQRCodeTargetId = data.id
      this.setQRCodeTargetFullName = data.fullName
      this.setQRCodeValidTimeModalVisible = true
    },
    // 设置二维码有效期模态框关闭时
    handleSetQRCodeValidTimeModalHide() {
      this.QRCodeValidTimeModalLoading = false
      this.QRCodevalidTimeForm = {
        validTimeType: 1,
        expiredTime: undefined
      }
    },
    // 确定二维码有效时间
    handleConfirmQRCodeValidTime() {
      this.$refs.QRCodevalidTimeForm.validate(async valid => {
        if (valid) {
          try {
            this.expiredTimeString = this.QRCodevalidTimeForm.expiredTime
              ? this.QRCodevalidTimeForm.expiredTime.format(
                'YYYY-MM-DD HH:mm:ss'
              )
              : moment()
                .add(100, 'years')
                .format('YYYY-MM-DD HH:mm:ss')
            this.QRCodeValidTimeModalLoading = true
            const res = await createQRCode({
              bindingTargetId: this.setQRCodeTargetId,
              bindingType: 2,
              expiredAt: this.expiredTimeString
            })
            this.codeString = res.data.collection[0]
            setTimeout(() => {
              this.setQRCodeValidTimeModalVisible = false
              this.QRCodeModalVisible = true
            }, 0)
          } catch (error) {}
        }
      })
    }
  }
}
</script>

<style scoped>
.textarea-words-limit {
  line-height: 16px;
  margin-bottom: 0;
  text-align: right;
  color: #999;
}
</style>
